import React from 'react'
import { NavLink } from 'react-router-dom';


function Navbar() {
    return (
        <div>
            <nav className="navbar navbar-expand-lg navbar-light bg-primary">
                <div className="container-fluid">
                <img src="/images/travellogo.jpg" alt="" width="30" height="24" class="d-inline-block align-text-top"/>
                    <a className="navbar-brand mx-3" href="#">Parag's World</a>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav mx-auto mb-10 mb-lg-0">
                            <li className="nav-item active ">
                                <NavLink exact className="nav-link  text-center " aria-current="page" to="/">
                                    Home
                                </NavLink>
                            </li>

                            <li className="nav-item active">
                                <NavLink exact className="nav-link text-center" to="/about">
                                    About
                                </NavLink>
                            </li>

                            <li className="nav-item active">
                                <NavLink exact className="nav-link  text-center" to="/services">
                                    Services
                                </NavLink>
                            </li>

                            <li className="nav-item active">
                                <NavLink exact className="nav-link  text-center" to="/signup">
                                    SignUp
                                </NavLink>
                            </li>

                            
                        </ul>

                    </div>
                </div>
            </nav>
        </div>
    )
}

export default Navbar
